import { LAWNLOVE, LAWNSTARTER } from '@/constants';

//eslint-disable-next-line import/prefer-default-export
export const themedComponentMixin = {
  computed: {
    themedClass() {
      return ['themed-component'];
    },
    isLawnlove() {
      return process.env.VUE_APP_BRAND_THEME === LAWNLOVE;
    },
    isLawnStarter() {
      return process.env.VUE_APP_BRAND_THEME === LAWNSTARTER;
    },
    brandDomain() {
      return process.env.VUE_APP_BRAND_DOMAIN;
    },
    brandName() {
      switch (process.env.VUE_APP_BRAND_THEME) {
        case LAWNLOVE:
          return 'Lawn Love';
        case LAWNSTARTER:
        default:
          return 'LawnStarter';
      }
    },
    brandPathName() {
      switch (process.env.VUE_APP_BRAND_THEME) {
        case LAWNLOVE:
          return 'lawnlove';
        case LAWNSTARTER:
        default:
          return 'lawnstarter';
      }
    },
  },
};
